import { render, staticRenderFns } from "./SelectItemsModal.vue?vue&type=template&id=b7523370&scoped=true&"
import script from "./SelectItemsModal.vue?vue&type=script&lang=js&"
export * from "./SelectItemsModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectItemsModal.vue?vue&type=style&index=0&id=b7523370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7523370",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7523370')) {
      api.createRecord('b7523370', component.options)
    } else {
      api.reload('b7523370', component.options)
    }
    module.hot.accept("./SelectItemsModal.vue?vue&type=template&id=b7523370&scoped=true&", function () {
      api.rerender('b7523370', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Modals/SelectItemsModal.vue"
export default component.exports